module.exports = "<md-dialog aria-label=\"{{popup.data.label}}\" style=\"width: 400px !important;\">\n  <form>\n    <div class=\"cmp-dia-grp\" style=\"width: inherit; min-width: inherit !important; padding: 35px !important; text-align: center\">\n      <div>\n        <p>{{popup.data.content}}</p>\n      </div>\n    </div>\n    <div class=\"layout-align-center-center layout-row\" style=\"padding: 0 20px 20px 20px !important;\">\n      <md-button ng-click=\"popup.ok()\" class=\"cmp-inv-qut md-primary\">\n        OK\n      </md-button>\n    </div>\n  </form>\n</md-dialog>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/popup.component/popup.html
// module id = 313
// module chunks = 0